/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    compact: { type: 'variant', values: [ true ] },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    mini: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { mini: true },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: null,
        icon: PaletteIconChevronDown,
        iconColor: '#000000',
        iconGap: 8,
        iconPaddingTop: 4,
        iconPosition: 'left',
        iconSize: 16,
        justifyContent: 'flex-start',
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        verticalAlign: 'middle'
      }
    },
    {
      if: { expanded: true },
      tokens: { icon: PaletteIconChevronUp }
    },
    {
      if: { focus: true },
      tokens: {
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        borderColor: '#000000',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        borderWidth: 2
      }
    },
    {
      if: { focus: true, mini: true },
      tokens: {
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        borderColor: '#000000',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        borderWidth: null
      }
    },
    {
      if: { hover: true },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0.1)', iconPaddingTop: 8 }
    },
    {
      if: { expanded: true, hover: true },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0.1)', iconPaddingTop: 0 }
    },
    {
      if: { pressed: true },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
    },
    {
      if: { focus: true, pressed: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        borderColor: '#000000',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        borderWidth: 2
      }
    },
    {
      if: { focus: true, mini: true, pressed: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        borderColor: '#000000',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        borderWidth: null
      }
    },
    { if: { compact: true }, tokens: {} }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: 'rgba(0, 0, 0, 0)',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 2,
    icon: PaletteIconChevronDown,
    iconColor: '#000000',
    iconGap: 8,
    iconPaddingTop: 4,
    iconPosition: 'right',
    iconSize: 16,
    justifyContent: 'space-between',
    paddingBottom: 14,
    paddingLeft: 22,
    paddingRight: 22,
    paddingTop: 14,
    textLine: 'none',
    verticalAlign: 'middle'
  }
}
export default theme
